﻿import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingEstate } from "@tabler/icons-react";
import { LocalidadesDef } from "./LocalidadesDef";

export const LocalidadesIcon = IconBuildingEstate;
export const LocalidadesHelpText = "* Aquí puede ver la lista de localidades de la ciudad seleccionada.";

export class Localidades extends Entity<LocalidadesDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new LocalidadesDef(), parentKeys);
        super.Form = import('./LocalidadesForm').then((module) => module.LocalidadesForm);
        this.Title = "Localidades";
        this.Icon = LocalidadesIcon;
        this.HelpText = LocalidadesHelpText;
    }
}